import script from "./ITMonitoringDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ITMonitoringDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ITMonitoringDashboard.vue?vue&type=style&index=0&id=8a37a722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a37a722"]])

export default __exports__